import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';

const JourneyEditFormWrapper = ({ children, ...props }) => {
  return children(props);
};

JourneyEditFormWrapper.propTypes = {
  children: PropTypes.any,
  initialJourney: PropTypes.object,
  onSubmit: PropTypes.func,
};

JourneyEditFormWrapper.defaultProps = {
  initialJourney: null,
  onSubmit: () => {
    /*noop*/
  },
};

export default withFormik({
  validateOnChange: true,
  validationSchema: Yup.object().shape({
    extra_costs: Yup.array().of(
      Yup.object().shape({
        amount: Yup.string().required('Amount is required'),
      })
    ),
  }),
  mapPropsToValues: ({ initialJourney }) => {
    return initialJourney;
  },
  handleSubmit: (journey, { props }) => {
    props.onSubmit(journey, {
      onSave: props.onSave,
    });
  },
  displayName: 'JourneyEditFormWrapper',
})(JourneyEditFormWrapper);
